module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iLWHJ"))).then(() => parcelRequire('d0iPb'));